import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import { mapActions } from 'vuex';

export default {
  props: {
    value: {
      type: String
    },
    prop: {
      type: String
    }
  },
  data: function data() {
    return {
      rules: [{
        required: true,
        trigger: 'change',
        message: this.$t('playTurbo.commonTemplate.creativeInfo.form.language.empty')
      }],
      languageList: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getLanguagesList();

            case 2:
              data = _context.sent;

              _this.languageList = data.sort(function (a, b) {
                return a.name.localeCompare(b.name);
              });

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: _extends({}, mapActions({
    getLanguagesList: 'config/getLanguagesList'
  }), {
    changeHandler: function changeHandler(v) {
      this.$emit('input', v);
    }
  })
};